import { usePageTitleTranslation } from 'libs/navigation';

import { useCreateLegalClient } from '../hooks';
import { CreateLegalClientView } from '../views';

export const CreateLegalClientContainer = () => {
  const { onSubmit, formError, submitLoading } = useCreateLegalClient();

  usePageTitleTranslation('client.createLegalClient.title');

  return (
    <CreateLegalClientView
      formError={formError}
      submitLoading={submitLoading}
      onSubmit={onSubmit}
    />
  );
};
